import React from 'react';
import { globalAdminFieldSchemesEntryPoint } from '@jira/admin-pages__field-schemes/src/globalAdminFieldSchemesEntryPoint.entrypoint.tsx';
import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdGlobalIssuesSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalIssuesSettings.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { globalSettingsIssueFieldSchemesConfigRoute } from '@jira/router-routes__admin-pages-field-schemes-routes/src/globalSettingsIssueFieldSchemesConfigRoute.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { conditionalPostOfficeJiraTopBannerResource } from '@jira/router-resources__post-office/src/conditionalPostOfficeJiraTopBannerResource.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { FieldSchemesSkeleton } from '@jira/platform__skeletons/src/ui/admin-pages/field-schemes/FieldSchemesSkeleton.tsx';
import type { Route } from '@atlassian/react-resource-router';

const pageEntryPoint = createPageEntryPoint({
	main: globalAdminFieldSchemesEntryPoint,
});

export const globalSettingsIssueFieldSchemesConfigRouteEntry: Route = createEntry(
	globalSettingsIssueFieldSchemesConfigRoute,
	() => ({
		group: 'global-settings',
		ufoName: 'global-admin.issues.field-schemes',
		layout: globalSettingsLayout,

		skeleton: () => {
			return <FieldSchemesSkeleton />;
		},

		navigation: {
			sidebarId: SidebarIdGlobalIssuesSettings,
			menuId: MenuIdSettings,
		},

		canTransitionIn: () => !fg('mc-nfa-soft-rollback'),

		resources: [
			...getNavigationResources(),
			navigationSidebarGlobalResource,
			conditionalPostOfficeJiraTopBannerResource,
		],

		entryPoint: () => {
			if (fg('mc-nfa-soft-rollback')) {
				return undefined;
			}

			return pageEntryPoint;
		},

		meta: {
			reporting: {
				packageName: 'jiraAdminPagesFieldSchemes',
				id: 'globalSettingsIssueFieldSchemes',
				teamName: 'Yamato',
			},
		},

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
